query MigrationLogsQuery(
  $page: Int
  $rowsPerPage: Int
  $filter: MigrationLogsFilterInput
) {
  migrationLogs(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      migrationId
      message
      createdAt
    }
  }
}
